import React from 'react';

import { useQuery } from '@apollo/client';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { GET_HAS_NEWS } from '../../../../graphql/local';
import { GetHasNewsResponse } from '../../DiscoverPage';
import { DEFAULT_URL, HITS_TYPES } from '../../const';
import { TabItem } from '../TabItem';
import useStyles from './styles';

interface TabsProps {
  selectedItem?: string;
  refine?: Function;
}

const Tabs: React.FC<TabsProps> = ({ selectedItem, refine }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const withLinks = !refine;

  const { data } = useQuery<GetHasNewsResponse>(GET_HAS_NEWS);
  const hasNews = data?.hasNews;

  return (
    <Box className={classes.wrapper}>
      <TabItem
        data-testid="allTab"
        value=""
        label={t('page.discover.all')}
        selectedItem={selectedItem}
        handleSelect={refine}
        link={withLinks ? `${DEFAULT_URL}/search` : undefined}
      />
      <TabItem
        data-testid="videosTab"
        label={t('page.discover.videos')}
        value={HITS_TYPES.VIDEO}
        selectedItem={selectedItem}
        handleSelect={refine}
        link={withLinks ? `${DEFAULT_URL}/videos` : undefined}
      />
      <TabItem
        data-testid="pathwaysTab"
        label={t('page.discover.pathways')}
        value={HITS_TYPES.PATHWAY}
        selectedItem={selectedItem}
        handleSelect={refine}
        link={withLinks ? `${DEFAULT_URL}/pathways` : undefined}
      />
      {hasNews && (
        <TabItem
          data-testid="newsTab"
          label={t('page.discover.text')}
          value={HITS_TYPES.NEWS}
          selectedItem={selectedItem}
          handleSelect={refine}
          link={withLinks ? `${DEFAULT_URL}/insights` : undefined}
        />
      )}
      {process.env.REACT_APP_BUILD_TYPE === 'stage' && (
        <TabItem
          data-testid="glossaryTab"
          label={t('page.discover.glossary')}
          value={HITS_TYPES.GLOSSARY}
          selectedItem={selectedItem}
          handleSelect={refine}
          link={withLinks ? `${DEFAULT_URL}/glossary` : undefined}
        />
      )}
    </Box>
  );
};

export default Tabs;
